import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { EmailHistory } from "../utils/types/emailHistory";

export const fetchEmailHistoryList = async (page: number, limit: number) => {
  const response = await axiosServices.get("/emailhistory", {
    params: {
      page,
      start: page * limit,
      limit,
    },
  });
  return {
    data: convertToCamelCase<EmailHistory[]>(response.data.data),
    total: response.data.total,
  };
};

export const emailPreviewReport = async (data: { [key: string]: string }) => {
  const response = await axiosServices.post(
    "/preview",
    convertToSnakeCase(data, ["showProspectsNotes", "showBerthTable"])
  );
  return response.data;
};
